module.exports = __webpack_public_path__ + "static/media/mataKaihei.a9c739fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/mataKaihei.png
// module id = 1704
// module chunks = 1